import { Page, Text, View, Document, StyleSheet, Font, Image, } from "@react-pdf/renderer";
import React from "react";
import LatoRegular from "../../Assets/Fonts/Lato-Font/Lato-Regular.ttf";
import LatoBold from "../../Assets/Fonts/Lato-Font/Lato-Bold.ttf";
import Heart from "../../Assets/Images/HEART.png";
import Soul from "../../Assets/Images/SOUL.png";
import Mind from "../../Assets/Images/MIND.png";
import Strength from "../../Assets/Images/STRENGTH.png";
import Header from "../../Components/GeneratePdf/Header";
import Footer from "../../Components/GeneratePdf/Footer";

// Font Register
Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

// Styles
const styles = StyleSheet.create({
  page: {
    //   flex: 1,
    flexDirection: "column",
    paddingHorizontal: 20, // Reduce or remove if needed
    paddingVertical: 10, // Reduce this value
    fontFamily: "Lato",
    paddingBottom: 0,
    //   justifyContent: 'space-between',
    //   padding: 5,
  },
  content: {
    flexGrow: 1,
  },
  footer: {
    marginTop: "auto",
  },
  headerBox: {
    display: "flex",
    marginBottom: 5,
    // marginBottom: 10,
  },
  title: {
    fontSize: 18,
    fontWeight: 700,
    color: "#426B88",
    // marginBottom: 10,
  },
  subTitle: {
    fontSize: 12,
    color: "#245775",
    marginTop: "5px",
    fontWeight: 400,
  },
  table: {
    width: "100%",
    borderWidth: 1,
    borderColor: "#ccc",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
    paddingVertical: 5,
    alignItems: "center",
    borderLeftWidth: 1,
    borderLeftColor: "#ccc",
    borderRightWidth: 1,
    borderRightColor: "#ccc",
  },
  tableHeader: {
    fontWeight: 400,
    border: "0px",
    backgroundColor: "#426B88",
    fontWeight: "bold",
    color: "white",
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    marginTop: 30,
    overflow: "hidden", // Ensures no unwanted space
    paddingVertical: 8,
  },
  container: {
    marginTop: "10px",
    marginLeft: "10px",
    width: "500px",
    height: "26px",
    flexDirection: "row",
    justifyContent: "space-evenly",
    alignItems: "center",
    backgroundColor: "#EAF1F5",
  },
  text: {
    color: "#00577D",
    fontWeight: "700",
    fontFamily: "Lato",
    fontSize: "12px",
  },
  headerCell: { color: "white", fontWeight: 400 },
  cellIndex: {
    width: "5%",
    textAlign: "center",
    fontSize: 10,
    color: "#394554",
  },
  cellQuadrant: {
    width: "17%",
    textAlign: "left",
    fontSize: 10,
    color: "#394554",
  },
  cellLogo: { width: "5%", textAlign: "center" },
  cellQuestion: {
    width: "38%",
    fontSize: 10,
    paddingHorizontal: 4,
    color: "#394554",
    fontWeight: 400,
  },
  cellScore: {
    width: "7%",
    textAlign: "center",
    fontSize: 10,
    color: "#394554",
  },
  cell: {
    flex: 1,
    fontSize: 10,
    paddingHorizontal: 4,
  },
  logo: {
    width: 14.3,
    height: 14.3,
  },
});
// Dummy Data Array
const dummyData = [
  {
    quadrant: "HEART",
    question: "When presented with a problem, [First Name] is most concerned with how the team is handling it.",
    s: 1, m1: 1, d1: 1, p1: 1, p2: 1, p3: 1, o1: 1, o2: 1, a: 1,
  },
  {
    quadrant: "SOUL",
    question: "[First Name]’s superpower is to rise above any situation to gain a wise perspective.",
    s: 1, m1: 1, d1: 1, p1: 1, p2: 1, p3: 1, o1: 1, o2: 1, a: 1,
  },
  {
    quadrant: "MIND",
    question: "When presented with a problem, [First Name] needs to understand the processes before starting.",
    s: 1, m1: 1, d1: 1, p1: 1, p2: 1, p3: 1, o1: 1, o2: 1, a: 1,
  },
  {
    quadrant: "STRENGTH",
    question: "When presented with a problem, [First Name] immediately starts working on it.",
    s: 1, m1: 1, d1: 1, p1: 1, p2: 1, p3: 1, o1: 1, o2: 1, a: 1,
  },
  {
    quadrant: "SOUL",
    question: "[First Name] evaluates decisions by their ability to fulfill the greater vision.",
    s: 1, m1: 1, d1: 1, p1: 1, p2: 1, p3: 1, o1: 1, o2: 1, a: 1,
  },
  {
    quadrant: "MIND",
    question: "[First Name] makes decisions based on the policies that guide them.",
    s: 1, m1: 1, d1: 1, p1: 1, p2: 1, p3: 1, o1: 1, o2: 1, a: 1,
  },
  {
    quadrant: "STRENGTH",
    question: "[First Name] makes decisions by focusing on what needs to get done.",
    s: 1, m1: 1, d1: 1, p1: 1, p2: 1, p3: 1, o1: 1, o2: 1, a: 1,
  },
  {
    quadrant: "HEART",
    question: "[First Name] ensures their decisions are measured by whether everyone is on board.",
    s: 1, m1: 1, d1: 1, p1: 1, p2: 1, p3: 1, o1: 1, o2: 1, a: 1,
  },
  {
    quadrant: "STRENGTH",
    question: "[First Name] feels most fulfilled when personal tasks are completed.",
    s: 1, m1: 1, d1: 1, p1: 1, p2: 1, p3: 1, o1: 1, o2: 1, a: 1,
  },
  {
    quadrant: "HEART",
    question: "[First Name] feels most fulfilled when surrounded by their people.",
    s: 1, m1: 1, d1: 1, p1: 1, p2: 1, p3: 1, o1: 1, o2: 1, a: 1,
  },
  {
    quadrant: "SOUL",
    question: "[First Name] is most fulfilled when living out a greater purpose.",
    s: 1, m1: 1, d1: 1, p1: 1, p2: 1, p3: 1, o1: 1, o2: 1, a: 1,
  },
  {
    quadrant: "MIND",
    question: "[First Name] is most fulfilled when a project works like it was planned.",
    s: 1, m1: 1, d1: 1, p1: 1, p2: 1, p3: 1, o1: 1, o2: 1, a: 1,
  },
];


// Truncate Text Function
const truncateText = (text, maxLength) => {
  return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};

// Quadrant Logo Function
const getQuadrantLogo = () => <Image src={Heart} style={styles.logo} />;

const QuadrantFlowItemFirst360 = ({ apiData }) => {
  const respondentName = apiData?.fullName?.split(' ')[0] || '[First Name]';
  return (
    <View style={styles.page}>
      {/* <Header /> */}

      <View>
        <Text style={styles.title}>QUADRANT FLOW 360 ITEMS OVERVIEW</Text>
        <Text style={styles.subTitle}>
          This page presents a ranking of all 40 items distributed across the
          four quadrants: Heart, Soul, Mind, and Strength™. The rankings are
          based on the OBSERVER ratings (SELF excluded), using a response scale
          that ranges from 1 (Least) to 4 (Most). Any unselected statement will
          appear as "-" in the Items Overview chart.
        </Text>
      </View>

      <View>
        {/* Table Header */}
        <View style={[styles.tableRow, styles.tableHeader]}>
          <Text style={[styles.cellIndex, styles.headerCell]}>#</Text>
          <Text style={[styles.cellQuadrant, styles.headerCell]}>Quadrant</Text>
          <Text style={[styles.cellLogo, styles.headerCell]}></Text>
          <Text style={[styles.cellQuestion, styles.headerCell]}>Question</Text>
          <Text style={[styles.cellScore, styles.headerCell]}>S</Text>
          <Text style={[styles.cellScore, styles.headerCell]}>M1</Text>
          <Text style={[styles.cellScore, styles.headerCell]}>D1</Text>
          <Text style={[styles.cellScore, styles.headerCell]}>P1</Text>
          <Text style={[styles.cellScore, styles.headerCell]}>P2</Text>
          <Text style={[styles.cellScore, styles.headerCell]}>P3</Text>
          <Text style={[styles.cellScore, styles.headerCell]}>O1</Text>
          <Text style={[styles.cellScore, styles.headerCell]}>O2</Text>
          <Text style={[styles.cellScore, styles.headerCell]}>A</Text>
        </View>

        {/* Table Rows */}
        {dummyData.length > 0 ? (
          dummyData.map((item, index) => (
            <View
              key={index} style={[ styles.tableRow, { backgroundColor: index % 2 === 0 ? "#F1F3F3" : "#FFF" }, ]} >
              <Text style={styles.cellIndex}>{index + 1}</Text>
              <Text style={styles.cellQuadrant}>{item.quadrant}</Text>
              <View style={styles.cellLogo}> {getQuadrantLogo(item.quadrant)} </View>
              <Text style={styles.cellQuestion}>{item.question.replace(/\[First Name\]/g, respondentName)} </Text>
              <Text style={styles.cellScore}>{item.s}</Text>
              <Text style={styles.cellScore}>{item.m1}</Text>
              <Text style={styles.cellScore}>{item.d1}</Text>
              <Text style={styles.cellScore}>{item.p1}</Text>
              <Text style={styles.cellScore}>{item.p2}</Text>
              <Text style={styles.cellScore}>{item.p3}</Text>
              <Text style={styles.cellScore}>{item.o1}</Text>
              <Text style={styles.cellScore}>{item.o2}</Text>
              <Text style={styles.cellScore}>{item.a}</Text>
            </View>
          ))
        ) : (
          <Text style={{ textAlign: "center", padding: 10 }}>
            No data available
          </Text>
        )}
      </View>
      <View style={styles.container}>
        <Text style={styles.text}>{"\u2022"} S - Self</Text>
        <Text style={styles.text}>{"\u2022"} M - Manager</Text>
        <Text style={styles.text}>{"\u2022"} D - Direct Report</Text>
        <Text style={styles.text}>{"\u2022"} P - Peer</Text>
        <Text style={styles.text}>{"\u2022"} O - Other</Text>
        <Text style={styles.text}>{"\u2022"} A - Average</Text>
      </View>
      {/* <Footer /> */}
    </View>
  );
};

export default QuadrantFlowItemFirst360;
